import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGear = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_21618_15547)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z",
			stroke: "white",
			strokeWidth: 1.49333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M3.88425 16.6959C3.46985 15.9821 3.15237 15.2163 2.94019 14.4187L4.51331 12.4499C4.4955 12.149 4.4955 11.8472 4.51331 11.5462L2.94112 9.57744C3.15294 8.7797 3.46977 8.01363 3.88331 7.29932L6.38737 7.01807C6.58733 6.79278 6.80052 6.57959 7.02581 6.37963L7.30706 3.8765C8.02035 3.46494 8.78517 3.14999 9.58144 2.93994L11.5502 4.51307C11.8512 4.49525 12.1529 4.49525 12.4539 4.51307L14.4227 2.94088C15.2204 3.1527 15.9865 3.46953 16.7008 3.88307L16.9821 6.38713C17.2073 6.58709 17.4205 6.80028 17.6205 7.02557L20.1236 7.30682C20.538 8.0206 20.8555 8.78639 21.0677 9.584L19.4946 11.5528C19.5124 11.8537 19.5124 12.1555 19.4946 12.4565L21.0667 14.4253C20.8564 15.2228 20.5412 15.9888 20.1292 16.7034L17.6252 16.9846C17.4252 17.2099 17.212 17.4231 16.9867 17.6231L16.7055 20.1262C15.9917 20.5406 15.2259 20.8581 14.4283 21.0703L12.4596 19.4971C12.1586 19.5149 11.8568 19.5149 11.5558 19.4971L9.58706 21.0693C8.78955 20.859 8.02349 20.5437 7.30894 20.1318L7.02769 17.6278C6.8024 17.4278 6.58921 17.2146 6.38925 16.9893L3.88425 16.6959Z",
			stroke: "white",
			strokeWidth: 1.49333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_21618_15547",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			rx: 5.33333,
			fill: "white"
		})
	}) })]
});
export default SvgGear;
